// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._154ize3t{top:var(--ds-space-0,0)}
._1pbyowjs{z-index:300}
._bfhk1j28{background-color:transparent}
._kqswstnw{position:absolute}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/datetime-picker/dist/esm/internal/fixed-layer.compiled.css"],"names":[],"mappings":"AAAA,WAAW,uBAAuB;AAClC,WAAW,WAAW;AACtB,WAAW,4BAA4B;AACvC,WAAW,iBAAiB","sourcesContent":["._154ize3t{top:var(--ds-space-0,0)}\n._1pbyowjs{z-index:300}\n._bfhk1j28{background-color:transparent}\n._kqswstnw{position:absolute}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
